import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import * as ReactHighcharts from 'react-highcharts';

const styles ={
  card:{
    width: '35%',
    marginLeft: 20
  },
  flexContentSB:{
    display: 'flex',
    justifyContent: 'space-between'
  },
  flexItemsCenter: {
    display: 'flex',
    alignItems: 'center'
  },
  valuesContainer: {
    paddingLeft: 10,
    color: '#7b7d7f'
  },
  chartContainer: {
    marginTop: '13%'
  }
}
const config= {

  xAxis: {
    type: 'datetime',
    dateTimeLabelFormats: {
      day: '%e %b'
    }
  },

  title: {
    text:''
  },
  
  yAxis: {
    title: {
        text: 'Donations amount'
    }
  },
 
  plotOptions: {
      series: {
          label: {
              connectorAllowed: false
          },
      }
  },

  tooltip: {
    valueDecimals: 2,
    valuePrefix: '£',
  },
  
  responsive: {
      rules: [{
          condition: {
              maxWidth: 500
          },
          chartOptions: {
              legend: {
                  layout: 'horizontal',
                  align: 'center',
                  verticalAlign: 'bottom'
              }
          }
      }]
  }

}

const DashboardOverview = ({totalCampaigns, totalDonations, classes, donations}) => {
  config.series = [{
    name:'donations amount',
      data: donations,
      pointStart: Date.now() - (7 * 24 * 60 * 60 * 1000), //last week
      pointInterval: 24 * 3600 * 1000 //one day
  }];
  return(
  <Card className={classes.card}>
    <CardContent>
        <Typography variant="display1" gutterBottom>OVERVIEW</Typography>
        {/* <div className={classes.flexContentSB}>
          <div className={classes.flexItemsCenter}>
            <CircularProgress variant="static" value={75} size={60} style={{transform: 'none'}} />
            <div className={classes.valuesContainer}>
              <Typography variant="body1" >Total Donation</Typography>
              <Typography variant="subheading">{totalDonations ? `£ ${totalDonations}` : ''}</Typography>
            </div>
          </div>
          <div className={classes.flexItemsCenter}>
            <CircularProgress variant="static" color="secondary" value={75} size={60} style={{transform: 'none'}} />
            <div className={classes.valuesContainer}>
            <Typography variant="body1" >Total Compaigns</Typography>
              <Typography variant="subheading">{totalCampaigns}</Typography>
            </div>
          </div>
        </div> */}
        <div className={classes.chartContainer}>
          <ReactHighcharts config={config} />
        </div>
    </CardContent>
  </Card>
)
}
export default withStyles(styles)(DashboardOverview)